import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createContenaire } from '../../../api/redux/slices/SuperAdmin';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../components/modal';

const AddContenaire = ({ addModalOpen, setAddModalOpen, onSuccess }) => {
    const dispatch = useDispatch();
    const [isFocus, setIsFocus] = useState(false);
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('accesstoken');

    const [values, setValues] = useState({
        nom: '',
        volume: '',
    });

    const handleAdd = (e) => {
        e.preventDefault();

        if (!values.nom.trim()) {
            showToast('Veuillez remplir le nom du contenaire', 'warn');
            return;
        }

        if (!values.volume || parseFloat(values.volume) <= 0) {
            showToast('Veuillez entrer un volume valide', 'warn');
            return;
        }

        const data = {
            nom: values.nom.trim(),
            volume: parseFloat(values.volume),
        };

        setLoading(true);
        dispatch(createContenaire({ token, data }))
            .unwrap()
            .then(() => {
                setValues({ nom: '', volume: '' });
                setIsFocus(false);
                toast.success('Contenaire ajouté', {
                    position: 'top-center',
                    autoClose: 2000,
                });
                setAddModalOpen(false);
                onSuccess?.(); // ← triggers fetchList() in parent
            })
            .catch((err) => {
                toast.error(err?.error || err?.message || 'Erreur lors de la création', {
                    position: 'top-center',
                    autoClose: 2000,
                });
            })
            .finally(() => setLoading(false));
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setValues({ nom: '', volume: '' });
        setIsFocus(false);
        setAddModalOpen(false);
    };

    return (
        <div className={'modalcontainer ' + (addModalOpen ? 'open' : '')}>
            <div className={'modal ' + (addModalOpen ? 'active' : '')}>
                <form onSubmit={handleAdd}>
                    <div className='label-input'>
                        <label>
                            Nom du contenaire <span style={{ color: '#e74c3c' }}>*</span>
                        </label>
                        <input
                            type='text'
                            placeholder='Nom'
                            value={values.nom}
                            onChange={(e) => {
                                setValues({ ...values, nom: e.target.value });
                                setIsFocus(true);
                            }}
                            required
                        />
                    </div>
                    <div className='label-input'>
                        <label>
                            Volume (m³) <span style={{ color: '#e74c3c' }}>*</span>
                        </label>
                        <input
                            type='number'
                            step='0.01'
                            min='0'
                            placeholder='Volume en m³'
                            value={values.volume}
                            onChange={(e) => {
                                setValues({ ...values, volume: e.target.value });
                                setIsFocus(true);
                            }}
                            required
                        />
                    </div>
                    <div className='submit-btns'>
                        <div className='add-btns'>
                            <button
                                className={isFocus ? 'button-nature' : 'button-nature-inactive'}
                                onClick={handleCancel}
                                disabled={loading}
                            >
                                Annuler
                            </button>
                            <button
                                className={isFocus ? 'button-primary' : 'button-primary-inactive'}
                                type='submit'
                                disabled={loading}
                            >
                                {loading ? 'Ajout...' : 'Ajouter'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddContenaire;